(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sn-scroll-word-reveal"] && !Shopify.designMode) return;
  try {
    
let scroll;

const clamp01 = (n) => Math.min(1, Math.max(0, n));

// Wrap each word of the heading's text nodes in a span, keeping inline markup (bold, links) intact
function splitWords(root) {
  if (root.querySelector('.sn-word-reveal__word')) return [...root.querySelectorAll('.sn-word-reveal__word')];

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((node) => {
    if (!node.textContent.trim()) return;
    const frag = document.createDocumentFragment();
    node.textContent.split(/(\s+)/).forEach((part) => {
      if (!part) return;
      if (/^\s+$/.test(part)) return frag.append(part);
      const span = document.createElement('span');
      span.className = 'sn-word-reveal__word';
      span.textContent = part;
      frag.append(span);
    });
    node.replaceWith(frag);
  });

  const words = [...root.querySelectorAll('.sn-word-reveal__word')];
  const last = Math.max(1, words.length - 1);
  words.forEach((word, i) => word.style.setProperty('--sn-word-reveal-p', `${((i / last) * 100).toFixed(1)}%`));
  return words;
}

class SnWordReveal extends HTMLElement {
  connectedCallback() {
    const heading = this.querySelector('[data-sn-word-reveal-heading]');
    const words = heading ? splitWords(heading) : [];
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const startOpacity = parseFloat(this.dataset.startOpacity) || 0.15;
    const spread = clamp01(parseFloat(this.dataset.spread) || 0.8);
    const wordDuration = parseFloat(this.dataset.wordDuration) || 0.2;

    const bar = this.querySelector('[data-sn-word-reveal-progress]');
    const axis = this.dataset.axis === 'x' ? 'X' : 'Y';
    const count = words.length;
    if (!count) return;

    const ranges = words.map((_, i) => {
      const start = count <= 1 ? 0 : (i / (count - 1)) * spread;
      return { start, end: Math.min(1, start + wordDuration) };
    });

    this.style.setProperty('--sn-word-reveal-start-opacity', startOpacity);
    this.classList.add('sn-word-reveal--ready');

    this.stop = scroll(
      (progress) => {
        if (bar) bar.style.transform = `scale${axis}(${progress})`;
        words.forEach((word, i) => {
          const { start, end } = ranges[i];
          const t = progress <= start ? 0 : progress >= end ? 1 : (progress - start) / (end - start);
          word.style.opacity = startOpacity + (1 - startOpacity) * t;
        });
      },
      { target: this, offset: ['start start', 'end end'] }
    );
  }

  disconnectedCallback() {
    this.stop?.();
    this.stop = null;
  }
}

if (!customElements.get('sn-word-reveal')) {
  import('@theme/m').then(({ scroll: motionScroll }) => {
    scroll = motionScroll;
    customElements.define('sn-word-reveal', SnWordReveal);
  });
}

  } catch(e) { console.error(e); }
})();
})();
